import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';

const initialState = {
  title: 'باربری‌ها',
  category: 'مدیریت باربری‌ها و سفارشات آنها ...',
  freightsModal: false,
  freightsList: [],
  choosedFreight: null,
  modalPage: 1,
  reportOfFreightOrder: null,
  reportOfFreightOrderPage: 0,
  reportOrderIds: [],
  addOrderItems: {
    origin: null,
    destination: null,
    cargoType: null,
    weight: null,
    weightType: null,
    fleetType: null,
    basePrice: null,
    priceBasedWeight: null,
    description: null,
    phone: null,
  },
  editOrderItems: {
    origin: null,
    destination: null,
    cargoType: null,
    weight: null,
    weightType: null,
    fleetType: null,
    basePrice: null,
    priceBasedWeight: null,
    description: null,
    phone: null,
  },
};

export const useFreight = create(
  persist(
    immer((set, get) => ({
      ...initialState,
      setTitle: (title) =>
        set((state) => {
          state.title = title;
        }),
      setCategory: (category) =>
        set((state) => {
          state.category = category;
        }),
      setOpenFreightsModal: (modal) =>
        set((state) => {
          state.freightsModal = modal;
        }),
      setFreights: (freights) =>
        set((state) => {
          state.freightsList = freights;
        }),
      setChoosedFreight: (freights) =>
        set((state) => {
          state.choosedFreight = freights;
        }),
      setMoadlPage: (page) =>
        set((state) => {
          state.modalPage = page;
        }),
      setOrderItems: (item, key) =>
        set((state) => {
          state.addOrderItems[key] = item;
        }),
      resetNewOrderForm: () =>
        set((state) => {
          state.addOrderItems = initialState.addOrderItems;
          state.choosedFreight = null;
        }),
      setEditedOrderForm: (item, key) =>
        set((state) => {
          state.editOrderItems[key] = item;
        }),
      resetEditOrderForm: () =>
        set((state) => {
          state.editOrderItems = initialState.editOrderItems;
        }),
      setReportsOfFreightOrder: (reports) =>
        set((state) => {
          state.reportOfFreightOrder = reports;
        }),
      setReportOfFreightOrderPage: (page) =>
        set((state) => {
          state.reportOfFreightOrderPage = page;
        }),
      setReportsOrderIds: (id, totalDocs) =>
        set((state) => {
          state.reportOrderIds = [...state.reportOrderIds, { id, totalDocs }];
        }),
    })),
    {
      name: '@footab/admin/freights',
      storage: createJSONStorage(() => sessionStorage),
      partialize: (state) =>
        Object.fromEntries(
          Object.entries(state).filter(([key]) =>
            ['choosedFreight', 'addOrderItems', 'editOrderItems'].includes(key)
          )
        ),
    }
  )
);
